import { render, staticRenderFns } from "./AlarmGeneralDonutVisionChart.vue?vue&type=template&id=6a2b4dc8&scoped=true&"
import script from "./AlarmGeneralDonutVisionChart.vue?vue&type=script&lang=js&"
export * from "./AlarmGeneralDonutVisionChart.vue?vue&type=script&lang=js&"
import style0 from "./AlarmGeneralDonutVisionChart.vue?vue&type=style&index=0&id=6a2b4dc8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b4dc8",
  null
  
)

export default component.exports